import React from 'react'
import { CgNotes } from 'react-icons/cg'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import Button, { ButtonProps } from '@mui/material/Button'

// original
type ObservationPopUpProps = ButtonProps & {
  observation: string
  customButtonStyle?: object
}

// MUI

const ObservationPopUp = ({
  observation,
  customButtonStyle,
  ...otherProps
}: ObservationPopUpProps) => {
  // Original
  const defaultButtonStyle = {
    fontSize: '2rem',
    display: 'flex',
    width: '100%',
    height: '100%',
    background: 'transparent',
    boxShadow: 'none',
    color: 'black',
  }

  const mergedStyle = customButtonStyle
    ? { ...defaultButtonStyle, ...customButtonStyle }
    : defaultButtonStyle

  const disabledButtonStyle = {
    ...mergedStyle,
    color: 'gray',
    cursor: 'not-allowed',
  }

  // MUI
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)
  const hasContent = observation && observation.trim() !== ''

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (hasContent) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const id = open ? 'simple-popover' : undefined
  return (
    <>
      <Button
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        style={hasContent ? mergedStyle : disabledButtonStyle}
        tabIndex={-1}
        {...otherProps}
      >
        <CgNotes />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: { width: '450px', overflowY: 'auto' },
          },
        }}
      >
        <Typography sx={{ p: 2 }}>{observation}</Typography>
      </Popover>
    </>
  )
}

export default ObservationPopUp
